<app-fleet-page-header
  (clearSearch)="model.setSearch('')"
  (filterChanged)="model.setFilter($event, true)"
  (rememberFiltersChanged)="model.setRememberFilters($event)"
  (searchChanged)="model.setSearch($event)"
  (sortChanged)="model.setOrder($event, true)"
  [columns]="state.columns$ | async"
  [counter]="(state.count$ | async) ?? 0"
  [defaultSortOrder]="state.defaultSortOrder$ | async"
  [rememberFilterValues]="state.rememberFilters$ | async"
  [search]="state.search$ | async"
  [showMobileMenuButton]="false"
  [sortOrder]="state.gridSortOrder$ | async"
  [templates]="{ countIcon }"
  titleText="ti-admin.menu.tsp-users"
></app-fleet-page-header>

<ng-template #countIcon>
  <app-icon-users [height]="22" [width]="22"></app-icon-users>
</ng-template>

<app-users-grid
  (favouriteClicked)="onFavouriteClick($event)"
  (loginAsClicked)="userManager.loginAsTspUser($event)"
  [displayColumns]="usersDisplayColumns"
  [loginAsAccessCheck]="[Resource.TSPUser, Action.LoginAs]"
  [sendInviteCheckAccess]="[Resource.TSPUser, Action.Update]"
></app-users-grid>
